import React from "react";
import { Button, Avatar } from "antd";
import { PlusOutlined, TeamOutlined } from "@ant-design/icons";
import PatientLayout from "../../Layouts/Patient/PatientLayout";

export default function MyAppointmentsPage() {
    const appointments = [
        { id: 1, date: "12 Aug 2026", doctor: "Dr. Mithra", status: "Approved" },
        { id: 2, date: "05 Aug 2026", doctor: "Dr. Anandi Gopal Joshi", status: "Pending" },
    ];

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "approved":
                return "badge-light-success text-success";
            case "pending":
                return "badge-light-secondary text-secondary";
            default:
                return "badge-light-primary text-primary";
        }
    };

    return (
        <PatientLayout
            title="My Appointments"
            rightContent={
                <div className="d-flex align-items-center gap-4">
                    <Avatar size={40} className="bg-light-primary text-primary" icon={<TeamOutlined />} />
                    <Button type="primary" icon={<PlusOutlined />} size="large">
                        New Appointment
                    </Button>
                </div>
            }
        >
            <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4 p-lg-5">
                    <div className="table-responsive">
                        <table className="table align-middle table-row-dashed fs-6 gy-4 mb-0">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0 border-bottom">
                                    <th>Date</th>
                                    <th>Doctor</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody className="fw-semibold text-gray-700">
                                {appointments.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.date}</td>
                                        <td>{item.doctor}</td>
                                        <td>
                                            <span className={`badge ${getStatusBadge(item.status)} px-3 py-2 rounded-pill fw-bold`}>
                                                {item.status}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="d-flex gap-2 flex-wrap">
                                                <button className="btn btn-warning btn-sm fw-semibold">Reschedule</button>
                                                <button className="btn btn-danger btn-sm fw-semibold">Cancel</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </PatientLayout>
    );
}
